import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';

const DonutChart = forwardRef(({ 
  data = [], 
  showLegend = true, 
  name = "", 
  centerTxt = ''
}, ref) => {

  const chartComponentRef = useRef(null);

  // Expose methods to parent component
  useImperativeHandle(ref, () => ({
    chart: chartComponentRef.current?.chart,
    clearSelection: () => {
      const chart = chartComponentRef.current?.chart;
      if (chart) {
        chart.series[0].data.forEach(point => {
          point.select(false);
        });
      }
    }
  }));

  const options = {
    chart: {
      type: 'pie',
      plotBackgroundColor: "transparent",
      plotBorderWidth: null,
      plotShadow: false,
    },
    title: {
      text: null
    },
    tooltip: {
      pointFormat: '{point.pointFormat}'
    },
    subtitle: {
      text: centerTxt, // Use centerTitle prop or fallback to name
      align: 'center',
      verticalAlign: 'middle',
      style: {
        fontSize: '16px',
        fontWeight: '500',
        color: '#333'
      },
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        showInLegend: true,
        cursor: 'pointer',
        point: {
          events: {
            click: function () {
              if (this.options.onClick) {
                this.options.onClick();
              }
            }
          }
        },
        dataLabels: {
          enabled: false,
          format: '<b>{point.name}</b>: {point.percentage:.1f} %',
          distance: -30,
          style: {
            fontWeight: '500',
            color: 'white',
            fontSize: '14px'
          }
        },

        innerSize: '60%',
        states: {
          select: {
            color: null,
          }
        }
      }
    },
    legend: {
      enabled: showLegend,
      labelFormatter: function () {
        return this.showLegendVal
          ? `${this.name} (${this.legendSuffix ? this.legendSuffix  : ''})`
          : this.name;
      },
      itemStyle: {
        fontSize: '12px',
        fontWeight: '500'
      }
    },
    series: [{
      name: name,
      colorByPoint: true,
      data: data
    }],
    credits: {
      enabled: false
    }
  };

  return (
    <div className="donut-chart-container" style={{ width: "100%" }}>
      <HighchartsReact
        ref={chartComponentRef}
        highcharts={Highcharts}
        options={options}
        containerProps={{ style: { width: '100%', margin: 0 } }}
      />
    </div>
  );
});

DonutChart.displayName = 'DonutChart';

export default React.memo(DonutChart);